export default __webpack_public_path__ + "static/traefik-ambassador-stickers-1-d9ee6c1cc8a4c06be7f6bbd8eddf078f.svg";